import React from 'react';
import { Link } from 'react-router-dom';
import styles from '../styles/IndustriesHome.module.css';

const industries = [
  { id: '01', name: 'Banking & Finance' },
  { id: '02', name: 'Insurance'},
  { id: '03', name: 'Transportation' },
  { id: '04', name: 'Manufacturing' },
  { id: '05', name: 'Retail & CPG' },
  { id: '06', name: 'Healthcare' },
  { id: '07', name: 'Real Estate' },
  { id: '08', name: 'Media & Ent.' },
  { id: '09', name: 'Telecom & ISV' },
  { id: '10', name: 'Energy & Utilities' },
  { id: '11', name: 'Automotive' },
  { id: '12', name: 'Education' },
];

export default function IndustriesHome() {
  return (
    <section className={styles.section}>
      <div className="container">
        <div className={styles.topRow}>
          <div className={styles.header}>
            <span className="section-label">Industries</span>
            <h2 className={styles.title}>
              How <span className={styles.accent}>InviteEngine</span> Supports High-Growth Industries
            </h2>
          </div>
          <p className={styles.introText}>
            We don’t believe in generic outreach. We’ve built specialized frameworks 
            to navigate the unique buying cycles of high-growth industries.
          </p>
        </div>

        <div className={styles.columnGrid}>
          {industries.map((item) => (
            <div key={item.id} className={styles.columnCard}>
              <div className={styles.idNumber}>{item.id}</div>
              <div className={styles.cardMain}>
                <h3 className={styles.industryName}>{item.name}</h3>
                <p className={styles.industryDesc}>{item.desc}</p>
              </div>
              <Link to="/contact" className={styles.exploreLink}>
                INQUIRE <span>→</span>
              </Link>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}